import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $SelectPayment = styled.div`
  display: flex;
  gap: ${spacing('lg')};
  text-align: left;

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
